/* =========================================================================
   Bundled collectible-set catalogs — a client mirror of the db/016 seed
   (production/db/016_collections.sql §4). Used offline / for guests / when
   GET /api/collections returns 503, so the Relics and Apostles sets still render
   their locked silhouettes without a server. Keys/titles/icons match the SQL
   row-for-row.

   The Feast Days set is intentionally NOT bundled: its 60 items are auto-derived
   per app.FeastDays server-side (keys 'feast_<FeastDayId>'), so offline it renders
   from the player's locally-earned feast badges (calendar view) only.
   ========================================================================= */
import type { CollectionItem, CollectionSet } from '../api';

const RELICS: CollectionItem[] = [
  { key: 'relic_true_cross', title: 'Relic of the True Cross', icon: '✝️', earnedUtc: null },
  { key: 'relic_holy_shroud', title: 'The Holy Shroud', icon: '🕊️', earnedUtc: null },
  { key: 'relic_veronica_veil', title: 'Veil of Veronica', icon: '🧣', earnedUtc: null },
  { key: 'relic_holy_lance', title: 'The Holy Lance', icon: '🗡️', earnedUtc: null },
  { key: 'relic_crown_thorns', title: 'Crown of Thorns', icon: '👑', earnedUtc: null },
  { key: 'relic_peter_chains', title: 'Chains of St. Peter', icon: '⛓️', earnedUtc: null },
  { key: 'relic_holy_manger', title: 'Relic of the Holy Manger', icon: '🍼', earnedUtc: null },
  { key: 'relic_scala_sancta', title: 'The Holy Stairs (Scala Sancta)', icon: '🪜', earnedUtc: null },
];

const APOSTLES: CollectionItem[] = [
  { key: 'apostle_peter', title: 'St. Peter', icon: '🔑', earnedUtc: null },
  { key: 'apostle_andrew', title: 'St. Andrew', icon: '✝️', earnedUtc: null },
  { key: 'apostle_james_great', title: 'St. James the Greater', icon: '🐚', earnedUtc: null },
  { key: 'apostle_john', title: 'St. John', icon: '🦅', earnedUtc: null },
  { key: 'apostle_philip', title: 'St. Philip', icon: '🍞', earnedUtc: null },
  { key: 'apostle_bartholomew', title: 'St. Bartholomew', icon: '📖', earnedUtc: null },
  { key: 'apostle_thomas', title: 'St. Thomas', icon: '📐', earnedUtc: null },
  { key: 'apostle_matthew', title: 'St. Matthew', icon: '📜', earnedUtc: null },
  { key: 'apostle_james_less', title: 'St. James the Less', icon: '🪓', earnedUtc: null },
  { key: 'apostle_jude', title: 'St. Jude Thaddaeus', icon: '🔥', earnedUtc: null },
  { key: 'apostle_simon', title: 'St. Simon the Zealot', icon: '🪚', earnedUtc: null },
  { key: 'apostle_matthias', title: 'St. Matthias', icon: '🎲', earnedUtc: null },
];

/** The three active sets as bundled fallbacks (Feast Days carries no static items;
    its badges come from local earnings offline). SortOrder mirrors db/016. */
export const BUNDLED_SETS: CollectionSet[] = [
  { key: 'feast_days', title: 'Feast Days', icon: '🎉', items: [] },
  { key: 'relics', title: 'Sacred Relics', icon: '⚱️', items: RELICS },
  { key: 'apostles', title: 'The Twelve Apostles', icon: '🕊️', items: APOSTLES },
];

/** Item keys that belong to the Relics set (drive the relic-token redeem UI). */
export const RELIC_KEYS: readonly string[] = RELICS.map((r) => r.key);
